<template>
	<div>
		<div id="content">
			<b-modal id="modMessage" hide-backdrop content-class="shadow" header-bg-variant="dark" header-text-variant="light" title="Transaction Classification Admin">
				<p class="my-4">{{message}}</p>
			</b-modal>
			<div class="row">
				<div class="m-5 mt-0">
					<h2>Transaction Classifications</h2>
				</div>
			</div>
				<b-overlay :show="this.loading" rounded="sm">
				<div class="row">
					<div class="col-md-4">
						<div class = "mb-2" v-if = "!createNew" >
							<b-button @click="newClassificationPressed()" variant="success"><b-icon-plus-circle font-scale="1.5"/> Create MG classification</b-button>
						</div>
						<div class = "mb-2" v-else>
							<b-button @click="cancelChange()" variant="danger"><b-icon-trash font-scale="1.5"/> Cancel</b-button>
						</div>
						<h2>Effective Classifications</h2>
						<p>The customer facing classifications:</p>
						<div v-if="this.effectiveTreeData !== null && this.effectiveTreeData.length != 0"> 
							<b-tree-view 
								:data="effectiveTreeData" 
								:contextMenuItems="contextMI"
								:renameNodeOnDblClick="false"
								nodeLabelProp = "displayName"
								@nodeSelect="selectMGClassification">
							</b-tree-view>
						</div>
						<div class="mt-5" v-if="this.openBankingClassificationsTreeData !== null &&  this.openBankingClassificationsTreeData.length != 0"> 
							<h2>OpenBanking Classifications</h2>
							<p>The original categories from our OpenBanking provider (currently TrueLayer).</p>
							<b-tree-view 
								:data="this.openBankingClassificationsTreeData" 
								:contextMenuItems="contextMI"
								:renameNodeOnDblClick="false"
								nodeLabelProp = "displayName"
								@nodeSelect="selectOBClassification">
							</b-tree-view>
						</div>
					</div>
					<div class="col" v-if="createNew">
						<div class="m-5 mt-0">
							<h2>Create a classification</h2>
							<ul>
								<li>  Do not use special characters including + and &, just write "and" </li>
								<li>  Do not go over 50 characters. If you think you're close, just please stop. Please. just stop. </li>
								<li>  If you do not know the asset, leave it empty but make someone aware. </li>
							</ul>
							classification: <b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['mgClassification']"></b-form-input>
							sub classification: <b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['mgSubClassification']"></b-form-input>
							icon asset name: <b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['iconPath']"></b-form-input>
							grandparent: <b-form-select class = "mb-2" v-model="selectedMGClassification.mgClassification.grandParentClassification" :options="grandparents" ></b-form-select>
							<b-button @click="createMGClassification()" variant="success"><b-icon-plus-circle font-scale="1.5"/> Save</b-button>
						</div>
					</div>
					<div class="col" v-else-if="selectedMGClassification !== null">
						<div class="col m-5 mt-0" v-if="selectedMGClassification.mgClassification['mgSubClassification'] !== null">
							<p>{{selectedMGClassification.mgClassification['mgClassification'] }}</p>
							<b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['mgSubClassification']"></b-form-input>
						</div>
						<div v-else>
							<b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['mgClassification']"></b-form-input>
						</div>
						icon asset name: <b-form-input class="mb-2" v-model="selectedMGClassification.mgClassification['iconPath']"></b-form-input>
						grandparent: <b-form-select class = "mb-2" v-model="selectedMGClassification.mgClassification.grandParentClassification" :options="grandparents" ></b-form-select>
						<p>There are <span style="font-size:22px; font-weight: bold">{{this.selectedMGClassification.numRulesOverriding}} rules</span> choosing this category, belonging to <span style="font-size:22px; font-weight: bold">{{this.selectedMGClassification.numUniqueCustomersOverriding}} customers</span>.</p>
						<p>Affecting <span style="font-size:22px; font-weight: bold">{{this.selectedMGClassification.numTransactionsUsingAsEffectiveClassification}} transactions</span>.</p>
						<p> Note on deletion: Deleting the category will restore any Open Banking classifications which map to it.</p>
						<div class = "mb-2 mt-2">
							<b-button class = "m-2" @click="updateMGClassification()" variant = "success"><b-icon-plus-circle font-scale="1.5"/> Save</b-button>
							<b-button class = "m-2" @click="deleteClassification()" variant = "danger"><b-icon-trash font-scale="1.5"/> Delete</b-button>
						</div>
						<div>
							<p> The following Open Banking classifications map to this classification.</p>
							<ul id="mappings">
								<li v-for="item in getOBClassificationsThatMapToMG(this.selectedMGClassification.mgClassification)" :key = "item">
									{{ item }}
								</li>
							</ul>
						</div>
					</div>
					<div class="col m-5 mt-0" v-else-if="selectedOBClassification !== null">
						<p style="font-size:28px;">
							OpenBanking: <span style="font-weight: bold"> {{this.classificationOBDisplayName(selectedOBClassification.originalClassification)}} </span>
						</p>
						<p style="font-size:28px;">
							Currently mapped to: 
							<span style="font-weight: bold"> {{this.classificationMGDisplayName(selectedOBClassification.mappedToClassification)}}</span>
						</p>
						<div>
							<b-button class="m-2" v-b-toggle.mgListCollapse variant="success"><b-icon-plus-circle font-scale="1.5"/> Edit</b-button>
							<b-collapse id = "mgListCollapse"> 
								<b-tree-view 
									:data="effectiveTreeData" 
									:contextMenuItems="contextMI"
									:renameNodeOnDblClick="false"
									nodeLabelProp = "displayName"
									@nodeSelect="selectMGClassificationForMapping">
								</b-tree-view>
								<div v-if="this.classificationMappingUpdateRequest.obClassification !== null">
									<p style="font-size:28=0px;">
										Update:<span style="font-weight: bold"> {{this.classificationOBDisplayName(this.classificationMappingUpdateRequest.obClassification)}}</span>
									</p>
									<p style="font-size:28=0px;">
										To map to: <span style="font-weight: bold">  {{this.classificationMGDisplayName(classificationMappingUpdateRequest.mgClassification)}}</span>
									</p>
									<div v-if="this.classificationMappingUpdateRequest.obClassification.subClassification !== null && this.classificationMappingUpdateRequest.mgClassification !== null && this.classificationMappingUpdateRequest.mgClassification.mgSubClassification == null">
										<p style="font-size:22=0px; color:red">You are mapping a child classification directly to a parent, not mapping it's parent. This operation will lose the granularity of the child name.</p>
									</div>
									<div class = "mb-2 mt-2">
										<b-button v-b-toggle.mgListCollapse @click="remapOBClassification" variant = "success"><b-icon-plus-circle font-scale="1.5"/> Save</b-button>
									</div>
								</div>
							</b-collapse> 
						</div>
					</div>
					<div class="col-md-6 m-5 mt-0" v-else>
						<div>
							<p>oh hello there. You know, we're all mad here. </p>
							<p>The <span style="font-weight: bold"> effective classifications list</span> is what the customers will see on the App. Possible actions include:</p>
							<ul>
								<li><span style="font-weight: bold"> Create</span> - create a new classification. You can map existing classifications to it once it is created.</li>
								<li><span style="font-weight: bold"> Delete</span> - If the classification was entirely an MG creation then it will be removed 
									<span style="font-weight: bold; color:red"> however, if it is mapped</span> 
									from an open banking classification then the delete action will strip it back to it's open banking form. Open banking classifications cannot be deleted, only mapped to something else.
								</li>
								<li><span style="font-weight: bold"> Edit</span> - you can edit the names of these classificaitons. But you won't be allowed to edit a parent and child in one go. Because that would be following the white rabbit.</li>
							</ul>
							<p>The <span style="font-weight: bold"> open banking classifications list</span> is the original classifications from Open Banking. Possible actions include:</p>
							<ul>
								<li><span style="font-weight: bold"> Change mapping</span> - If you want to change what an open banking classification is mapped to, 
									then a drop down list of the available classifications you can select from is presented for you to choose from. Don't forget to click save.
									There is a <span style="font-weight: bold"> cascade effect</span> if you map a parent, so all the children will become children of whatever you mapped the parent to.
									You may need to create the classification you are trying to map to first if you can't see it in the list. 
								</li>
							</ul>
							<h2>now, select a classification...</h2>
						</div>
					</div>
				</div>
			</b-overlay>
		</div>
	</div>
</template>
<script>
import { bTreeView } from 'bootstrap-vue-treeview'
/*

ALL THE REFACTORING
- and also don't allow ampersands. or give warning it's an "and"

*/
export default {
  name: 'TransactionClassifications',
  data() {
	return{
		selectedMGClassification: null,
		selectedOBClassification: null,
		effectiveTreeData: null,
		openBankingClassificationsTreeData: null,
		classificationMappingUpdateRequest: null,
		createNew: false,
		loading: false,
		message: null,
		error: null,
		grandparents: [
			{value: 0, text : "Income"},
			{value: 1, text : "Future planning"},
			{value: 2, text : "Everyday spend"},
			{value: 3, text : "Fixed costs"} ]
	}
  },
  props: {
	contextMI: {
		type: Array,
		default: function() { return [] }
	},
  },
  components: {
	bTreeView
  },
  computed: {
		buttonColor () {
			return this.classificationMappingUpdateRequest.mgClassification != null ? "success" : "light";
		}
  },
  methods: {
	selectMGClassification: function(node, isSelected) {
		this.selectedOBClassification = null;
		if (isSelected) {
			this.clearMappingRequest();
			this.selectedMGClassification = node.data;
			this.classificationMappingUpdateRequest.mgClassification = this.selectedMGClassification.mgClassification;
		} 
	},
	selectOBClassification: function(node, isSelected) {
		this.selectedMGClassification = null;
		if (isSelected) {
			this.clearMappingRequest();
			this.selectedOBClassification = node.data;
			this.classificationMappingUpdateRequest.obClassification = this.selectedOBClassification.originalClassification;
		} 
	},
	clearMappingRequest: function() {
		this.createNew = false;
		this.classificationMappingUpdateRequest = {
			"mgClassification":null,
			"obClassification":null,
		};
	},
	updateMGClassification: function() {
		this.$http.put(this.$config.ApiUri + "/TransactionClassifications/" + this.selectedMGClassification.mgClassification.id, this.selectedMGClassification.mgClassification)
			.then((result) => {
				if (result.status == 200) {
					this.refreshData();
					this.showMessage("Classification saved OK!");
				} else if (result.status == 400) {
					this.showMessage(result.data.message);
					this.loading = false;
				} else {
					this.showMessage("Unknown error");
					this.loading = false;
				}
			}
		).catch((e) => { console.log(e); this.showError(e); })
		.finally(() => {
			return true;
		});
	},
	selectMGClassificationForMapping: function(c, isSelected) {
		if (isSelected) {
			if (c.data.mgClassification.mgClassification != null) {
				this.classificationMappingUpdateRequest.mgClassification = c.data.mgClassification;
			} else {
				this.showMessage("Error selecting an MG classification");
			}
		} 
	},
	remapOBClassification: function() {
		if (this.classificationMappingUpdateRequest.mgClassification == null || this.classificationMappingUpdateRequest.obClassification == null) {
			this.showMessage("Either a classification has not been selected to edit or an MG classification is not set as the mapping.");
			this.clearMappingRequest();
		}
		this.loading = true;
		this.createNew = false;
		var request = {
			"mgClassificationID": this.classificationMappingUpdateRequest.mgClassification.id,
			"obClassificationID": this.classificationMappingUpdateRequest.obClassification.id,
		}
		this.$http.post(this.$config.ApiUri + "/TransactionClassifications/UpdateRequests", request)
			.then((result) => {
				if (result && result.data.success) {
					this.refreshData();
					this.showMessage("Classification remapped OK!");
				} else {
					this.showMessage(result.data.message);
					this.loading = false;
				}
			}
		).catch((e) => { console.log(e); this.showError(e); })
		.finally(() => {
			return true;
		});
	},
	createMGClassification: function() {
		this.loading = true;
		this.createNew = false;
		var selectedClassificationString = JSON.parse(JSON.stringify(this.selectedMGClassification));
		for (var key in selectedClassificationString.mgClassification) {
			if (selectedClassificationString.mgClassification[key] === "") {
				selectedClassificationString.mgClassification[key] = null;
			}
		}
		this.$http.post(this.$config.ApiUri + "/TransactionClassifications", selectedClassificationString.mgClassification)
			.then((result) => {
				if (result) {
					this.refreshData();
					this.showMessage("Classification created!");
					this.selectedMGClassification = null;
					return result.data;
				} else {
					this.loading = false;
				}
			}).catch(() => { this.showError(); })
			.finally(() => {
				return true;
			});
		return true;
	},
	removeMGMapping: function() {
		this.selectedMGClassification.mgClassificationIDString = null;
		this.remapOBClassification();
	},
	newClassificationPressed: function() {
		this.createNew = true;
		this.selectedOBClassification = null;
		this.selectedMGClassification = {
			"mgClassification" : {
				"mgClassification": "", 
				"mgSubClassification": "",
				"iconPath": "",
				"grandParentClassification": 0
			}
		};
	},
	deleteClassification: function() {
		this.loading = true;
		this.$http.delete(this.$config.ApiUri + "/TransactionClassifications/" + this.selectedMGClassification.mgClassification.id)
			.then((result) => {
				if (result && result.data.success) {
					this.refreshData();
					this.showMessage("Classification deleted successfullly.");
					this.selectedMGClassification = null;
					this.selectedOBClassification = null;
				} else {
					this.showMessage(result.data.message);
					this.loading = false;
				}
			}
		).catch((e) => { this.showError(e); })
		.finally(() => {
			return true;
		});
	},
	cleanClassificationValues: function(c) {
		for (var k in c) {
			if (c[k] == ""){
				c[k] = null;
			}
		}
		return c;
	},
	classificationMGDisplayName: function(c) {
		if (c == null) { return ``; }
		return `${c.mgClassification}${c.mgSubClassification != null ? `, ${c.mgSubClassification}` : ``}`;
	},
	classificationOBDisplayName: function(c) {
		return `${c.classification}${c.subClassification != null ? `, ${c.subClassification}` : ``}`;
	},
	cancelChange: function() {
		this.createNew = false;
		this.selectedMGClassification = this.effectiveTreeData[0];
	},
	refreshData: function() {
		this.getMGClassificationsListRequest(false);
		this.getOBClassificationsListRequest();
	},
	getOBClassificationsThatMapToMG: function(mgClassification) {
		var mapsToMGList = [];
		this.openBankingClassificationsTreeData.forEach((obClassification) => {
			if (obClassification.mappedToClassification.id == mgClassification.id) {
				mapsToMGList.push(this.classificationOBDisplayName(obClassification.originalClassification));
			}
			obClassification.children.forEach((childOB) => {
				if (childOB.mappedToClassification.id == mgClassification.id) {
					mapsToMGList.push(this.classificationOBDisplayName(childOB.originalClassification));
				}
			});
		});
		return mapsToMGList;
	},
	getMGClassificationsListRequest: function(type, stopLoadingOnComplete = true) {
		this.loading = true;
		this.$http.get(this.$config.ApiUri + "/TransactionClassifications?lite=false")
			.then((result) => {
				this.effectiveTreeData = this.displayNameMG(result.data);
				if (stopLoadingOnComplete) { this.loading = false; }
			}
		).catch((e) => { this.showError(e); })
		.finally(() => {
			return true;
		});
	},
	getOBClassificationsListRequest: function(type, stopLoadingOnComplete = true) {
		this.loading = true;
		this.$http.get(this.$config.ApiUri + "/TransactionClassifications?lite=false&getOpenBankingList=true")
			.then((result) => {
				this.openBankingClassificationsTreeData = this.displayNameOB(result.data);
				if (stopLoadingOnComplete) { this.loading = false; }
			}
		).catch((e) => { this.showError(e); })
		.finally(() => {
			return true;
		});
	},
	displayNameMG: function (list) {
		list.forEach((item) => { 
			item["displayName"] = `${item.mgClassification.mgClassification}` ;
			item.children.forEach((child) => { 
				child["displayName"] = `${child.mgClassification.mgSubClassification}` ;
			});
		});
		return list;
	},
	displayNameOB: function (list) {
		list.forEach((item) => { 
			item["displayName"] =`${item.originalClassification.classification}`;
			item.children.forEach((child) => { 
				child["displayName"] = `${child.originalClassification.subClassification}`;
			});
		});
		return list;
	},
	showMessage(message) {
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 4000);
	},
	showError(message) {
		if (!message) { message = "Sorry, that didn't work, please contact Cline"; }
		this.message=message;
		this.$bvModal.show('modMessage');
		setTimeout(() => this.$bvModal.hide('modMessage'), 4000);
	},
	onLoad() {
		this.loading = true;
		this.refreshData();
	}
  },
  mounted: function() { this.onLoad(); }
}
</script>

<style>
.modal-header .close {
  display:none;
}
</style>